import { Alert, Button, Paper, Stack } from '@mui/material';

type FileStorageAccessDeniedPanelProps = {
  message: string;
  onReturnToRoot: () => void;
};

export const FileStorageAccessDeniedPanel = ({
  message,
  onReturnToRoot,
}: FileStorageAccessDeniedPanelProps) => (
  <Paper variant="outlined" sx={{ mt: 1.5, p: 2 }}>
    <Stack spacing={1.5} alignItems="flex-start">
      <Alert severity="warning" sx={{ width: '100%' }}>
        {message}
      </Alert>
      <Button variant="contained" onClick={onReturnToRoot}>
        Return to root directory
      </Button>
    </Stack>
  </Paper>
);
